import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import BookingForm from "../components/BookingForm";
import PopupForm from "../components/PopupForm";
import FloatingBar from "../components/FloatingBar";
import AreaCarousel from "../components/AreaCarousel";
import ContactCards from "../components/ContactCards";
import WhyChooseUs from "../components/WhyChooseUs";

export default function Home() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const visited = localStorage.getItem("ro_first_visit");
    if (!visited) {
      setTimeout(() => setShowPopup(true), 3000);
      localStorage.setItem("ro_first_visit", "true");
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>RO Service Ranchi</title>
        <meta
          name="description"
          content="Same day RO water purifier repair, installation & AMC services in Patna. Call or WhatsApp now for fast service."
        />
        <meta name="keywords" content="ro service, water purifier service in Patna, ro repair, ro service near me, water purifier service near me, RO Service Patna, RO Service Patna near me, ro service centre, ro service centre in Bihar" />
        <meta name="keywords" content="ro service in Patna" />
        <meta name="keywords" content="Water purifier service in Patna" />
        <meta name="keywords" content="ro repair in Patna" />
        <meta name="author" content="Wappotix Pvt Ltd" />
        <meta name="description" content="RO Service Patna: We are India's leading RO water purifier repair and maintanance service provider of all brands like Kent, Pureit, Livpure, Aqua Guard, Aqua Fresh etc. RO repair service in Patna" ></meta>

      </Helmet>

      {/* ================= HERO ================= */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-text">
            <h1>RO Water Purifier Service & Repair in Patna</h1>
            <p>Same Day Service | Expert Technicians | Genuine Spare Parts</p>

            <div className="hero-buttons">
              <a href="tel:9031062013" className="btn-green">📞 Call Now</a>
              <a href="#contact" className="btn-blue">📋 Book Service</a>
            </div>

            <div className="hero-badges">
              <span>⭐ 4.8 Rated on Google</span>
              <span>5000+ Happy Customers</span>
              <span>10+ Years Experience</span>
            </div>
          </div>

          <div className="hero-image">
            <img src="/img/repairimg.png" alt="RO Purifier" />
          </div>
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section id="services" className="services">
        <h2>Our Services</h2>
        <div className="service-grid">
          <div className="service-card">
            <img src="/img/services/reppic.png" alt="RO Repair" />
            <h4>RO Repair</h4>
            <p>Fast and reliable RO repair services to restore pure drinking water at your home. Expert technicians ensure quick diagnosis and lasting solutions.</p>
            <a href="#contact" className="btn">Book</a>
          </div>
          <div className="service-card">
            <img src="/img/services/inspic.png" alt="Installation" />
            <h4>Installation</h4>
            <p>Professional RO installation for homes and offices with perfect fitting and setup. Enjoy safe, clean water from day one.</p>
            <a href="#contact" className="btn">Book</a>
          </div>
          <div className="service-card">
            <img src="/img/services/amcpic.png" alt="AMC" />
            <h4>AMC Plans</h4>
            <p>Affordable Annual Maintenance Contracts for worry-free RO performance all year. Regular servicing, priority support, and genuine spare parts included.</p>
            <a href="#contact" className="btn">Book</a>
          </div>
          <div className="service-card">
            <img src="/img/services/filpic.png" alt="Filter" />
            <h4>Filter Replacement</h4>
            <p>Timely filter replacements to maintain water purity and system efficiency. We use high-quality filters for better taste and safety.</p>
            <a href="#contact" className="btn">Book</a>
          </div>
          <div className="service-card">
            <img src="/img/services/compic.png" alt="Commercial" />
            <h4>Commercial RO</h4>
            <p>High-capacity commercial RO solutions for offices, schools, hospitals, and industries. Designed for consistent performance and large water demands.</p>
            <a href="#contact" className="btn">Book</a>
          </div>
        </div>
      </section>

      {/* ================= BOOKING ================= */}
      <section className="booking-section">
        <h2>Easy & Quick Booking</h2>
        <BookingForm />
      </section>

      {/* ================= WHY US ================= */}
      <WhyChooseUs />

      {/* ================= REVIEWS ================= */}
      <section className="reviews">
        <h2>Customer Reviews</h2>
        <div className="review-grid">
          <div className="review-card">
            <div className="review-image-name">
              <img src="/img/review/04.jpg" alt="Customer" />
              <strong>- Anjali S.</strong>
            </div>
            <div className="review-content">
              <p>Great service! Technician arrived on time and fixed my RO quickly. Highly recommended!</p>
              ⭐⭐⭐⭐⭐
            </div>
          </div>
          <div className="review-card">
            <div className="review-image-name">
              <img src="/img/review/02.jpg" alt="Customer" />
              <strong>- Vikas R.</strong>
            </div>
            <div className="review-content">
              <p>Fast and affordable. Very professional team. Thanks for the quick repair!</p>
              ⭐⭐⭐⭐⭐
            </div>
          </div>
        </div>
      </section>

      {/* ================= AREAS ================= */}
      <AreaCarousel />

      {/* ================= CONTACT ================= */}
      <ContactCards />

      <FloatingBar />
      <PopupForm show={showPopup} onClose={() => setShowPopup(false)} />
    </>
  );
}